import React from 'react';
import { TrendingDown, Timer, CalendarX, Users } from 'lucide-react';
import { problemsData } from '../data/mock';

const iconMap = {
  TrendingDown,
  Timer,
  CalendarX,
  Users,
};

const ProblemSection = () => {
  return (
    <section className="section bg-[#0F0F15]" id="problem">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-sm font-semibold text-[#FF6B35] uppercase tracking-wider mb-4">
            The Problem
          </span>
          <h2 className="heading-1 mb-4">
            Your Social Media Is Leaving Wins on the Table
          </h2>
          <p className="body-large">
            You've built the following. Now it's time to convert that momentum into real results.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {problemsData.map((problem, index) => {
            const IconComponent = iconMap[problem.icon];
            return (
              <div 
                key={problem.id} 
                className="card group animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-14 h-14 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center mb-4 group-hover:bg-red-500/20 transition-colors">
                  <IconComponent size={28} className="text-red-400" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {problem.title}
                </h3>
                <p className="body-medium text-[#6B6B78]">
                  {problem.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
